<template>
    <!-- 这里是路径导航组件 -->
    <div class="container">
        <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <!-- 首頁 -->
                <el-breadcrumb-item to="/main">{{$t("message.breadcrumb.title1")}}</el-breadcrumb-item>
                <!-- 商品列表页 -->
                <el-breadcrumb-item 
                    v-if="$route.name=='plist'&& !$route.query.id">
                    <span>{{$t("message.breadcrumb.title2")}}</span>
                </el-breadcrumb-item>
                <!-- 分類 -->
                <el-breadcrumb-item 
                    v-for="item in breadCrumb" 
                    :key="item.id">
                    <router-link :to="{ name: 'plist', query: {id:item.id} }">{{item.cat_name}}</router-link>
                </el-breadcrumb-item>
                <!-- 品牌 -->
                <!-- <el-breadcrumb-item v-if="brandName">
                    <router-link :to="{ name: 'plist', query: {id, brand: brandId} }">{{brandName}}</router-link>
                </el-breadcrumb-item> -->
                <!-- 詳情頁 -->
                <el-breadcrumb-item
                    v-if="$route.name === 'pdetail'">
                    {{goods.goods_name}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
    computed: mapState({
        // 面包屑导航
        breadCrumb: state => state.goods.breadCrumb,
        // brandId: state => state.goods.brandId,
        // brandName: state => state.goods.brandName,
        // 詳情頁數據
        goods: state => state.goods.goods,
        // id(state){
        //     let bc = state.goods.breadCrumb;
        //     if(!(bc == false)){
        //         return bc[bc.length - 1].id;
        //     }
        // }
    }),
}
</script>

<style scoped>
.breadcrumb{
    margin: 10px 0;
}
</style>
